import React from 'react';
import Helmet from 'react-helmet';
import { StatsPage } from '@zg-rentals/particles-js-debug';
import { connect } from 'react-redux';

const StatsPageWrapper = ({ stats }) => {
  return (
    <>
      <Helmet
        meta={[
          {
            name: 'robots',
            content: 'noindex, nofollow',
          },
        ]}
      />
      <StatsPage statsByName={stats} />
    </>
  );
};

const mapStateToProps = (state) => ({
  stats: state.app.stats,
});

export default connect(mapStateToProps)(StatsPageWrapper);
